<template>
    <b-card class="card-accent-danger" header-tag="header" footer-tag="footer" no-body>
        <template v-slot:header>
            <i class="fa-regular fa-syringe"></i> <strong>Vaccinations</strong>
            <div class="card-header-actions">
                <b-link class="card-header-action btn-minimize" @click="visible = !visible">
                    <i class="fa-regular" :class="visible ? 'fa-square-caret-up' : 'fa-square-caret-down'"></i>
                </b-link>
            </div>
        </template>
        <b-collapse v-model="visible">
            <vaccinations-base borderless :callback="createVaccination" />
        </b-collapse>
    </b-card>
</template>
<script>
import ComponentExtension from "@/core/components/ComponentExtension"
import { mapGetters, mapState, mapActions } from "vuex"
import VaccinationsBase from './VaccinationsBase'

export default ComponentExtension.extend({
    name: "vaccinations",
    components: {
        'vaccinations-base': VaccinationsBase
    },
    methods: {
        ...mapActions('vaccinations', ['createVaccination']),
    }
})
</script>